import { Suspense } from 'react';
import { HeaderIcon, IconCart } from '@banhala/ui-kit';
import { bridge, useNavigator } from 'shared/src/utils';
import { useSuspenseQuery } from '@tanstack/react-query';
import { cartService } from 'shared/src/api';
import { queryKey } from 'shared/src/constant';
import { useGetScreensInfiniteQuery } from './hooks/useGetScreensInfiniteQuery';
import type { AnyObject } from 'shared/src/types';

const logClickCart = (logging: AnyObject | undefined) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_CART',
    analytics: logging?.analytics,
    ably_only_log: logging?.ably_only_log,
  });
};

const handlePressIconCart = (
  navigator: ReturnType<typeof useNavigator>['navigator'],
  logging: AnyObject | undefined,
) => {
  logClickCart(logging);
  navigator.moveToWebview('Cart');
};

export const CartIcon: React.FC = () => {
  const { navigator } = useNavigator();
  const { data } = useGetScreensInfiniteQuery();

  return (
    <Suspense
      fallback={
        <HeaderIcon
          onPress={() => {
            handlePressIconCart(navigator, data?.logging);
          }}
        >
          <IconCart />
        </HeaderIcon>
      }
    >
      <CartIconInternal />
    </Suspense>
  );
};

const CartIconInternal = () => {
  const { navigator } = useNavigator();
  const { data: cartsCount } = useSuspenseQuery({
    queryKey: queryKey.cartMeta,
    queryFn: cartService.getCartMeta,
    select: data => data.carts_count,
  });
  const { data } = useGetScreensInfiniteQuery();
  return (
    <HeaderIcon
      onPress={() => {
        handlePressIconCart(navigator, data?.logging);
      }}
      badgeNum={cartsCount ?? 0}
    >
      <IconCart />
    </HeaderIcon>
  );
};
